import { Box } from "@mui/material";
import FilterForm from "./Utilities/FilterForm";
import BasicTextField from "../../../v2/common/BasicTextField";
import SearchIcon from "@mui/icons-material/Search";
import WordCloudComponent from "./WordCloud";
import useAnalyze from "./Utilities/hooks/useAnalyze";
import SearchComponent from "./SearchComponent";

export default function Analyze() {
  const {
    channelsList,
    channelIds,
    filterParams,
    setFilterParams,
    handleSubmit,
    searchInput,
    handleSearchField,
    handleSearchOnKeyDown,
    wordCloud,
    loadingWordCloud,
    handleWordCloudWordClick,
    handlePageChange,
    exporting,
    handleExport,
    handleBackButton,
    handleGenerateReport,
    generatingReport,
  } = useAnalyze();

  const currentView = filterParams.view;

  return (
    <Box sx={styles.rootWrapper}>
      <Box sx={styles.container}>
        <Box sx={styles.containerLeft}>
          <FilterForm
            startDate={filterParams.startDate}
            endDate={filterParams.endDate}
            channelsFilter={channelsList}
            channelsAction={filterParams.channels}
            channelsIds={channelIds}
            direction={filterParams.direction}
            onChange={(partial) => {
              setFilterParams((prev) => ({ ...prev, ...partial }));
            }}
            handleSubmit={handleSubmit}
            handleGenerateReport={handleGenerateReport}
            generatingReport={generatingReport}
          />
        </Box>

        <Box sx={styles.containerRight}>
          <Box
            sx={{
              width: "100%",
              backgroundColor: "#FFFFFF",
              borderRadius: "8px",
            }}
          >
            <BasicTextField
              name={"searchMessage"}
              startIcon={<SearchIcon sx={styles.icon} />}
              placeholder={"Search"}
              value={searchInput}
              handleChange={handleSearchField}
              sx={styles.textField}
              onKeyDown={handleSearchOnKeyDown}
            />
          </Box>

          {currentView === "search" && (
            <SearchComponent
              page={filterParams.page}
              handlePageChange={handlePageChange}
              exporting={exporting}
              handleExport={handleExport}
              handleBackButton={handleBackButton}
            />
          )}

          {currentView === "wordcloud" && (
            <WordCloudComponent
              words={wordCloud}
              loading={loadingWordCloud}
              onWordClick={handleWordCloudWordClick}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
}

const styles = {
  rootWrapper: {
    backgroundColor: "#EDEDE4",
    pt: 16,
    pb: 10,
    minHeight: "100vh",
  },
  container: {
    px: { xs: 2, sm: 6 },
    maxWidth: "1440px",
    display: "flex",
    gap: "40px",
    alignItems: "flex-start",
    flexDirection: { xs: "column", md: "row" },
  },
  containerLeft: {
    minWidth: "290px",
    maxWidth: "290px",
    padding: "33px",
    background: "#FFFFFF",
    borderRadius: "8px",
    border: "1px solid #dee2e0",
    boxShadow: "0 2px 4px 0 rgba(196, 201, 199, 0.5)",
  },
  containerRight: {
    width: "100%",
    minWidth: 0,
    maxWidth: "100%",
  },
  resultText: {
    fontFamily: "FustatMedium",
    fontSize: "16px",
    color: "#302E2A",
  },
  searchButton: {
    width: "100px",
    height: "38px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  textField: {
    height: "50px",
    [`& fieldset`]: {
      borderRadius: "8px",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderWidth: "1.5px",
        borderColor: "#9EA9A9",
      },
      "&:hover fieldset": {
        borderColor: "#687979",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#003300",
      },
    },
  },
  icon: {
    color: "#495D5E",
  },
  ellipsis: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
};
